import { useDialog } from '@dni-hooks/useDialog'
import { Dialog } from '@mui/material'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  container: {
    padding: 16,
    gap: 8,
    backgroundColor: colors.grey100,
    width: 320,
  },
})

export const DIALOG_CHECKOUT_NOTIFY = 'DIALOG_CHECKOUT_NOTIFY'

interface DialogCheckoutNotifyProps {
  title: ReactNode
  content: ReactNode
  onConfirm?: () => void
}

export function DialogCheckoutNotify() {
  const { open, closeDialog, title, content, onConfirm } = useDialog<DialogCheckoutNotifyProps>(DIALOG_CHECKOUT_NOTIFY)

  return (
    <Dialog disablePortal open={open} PaperProps={{ sx: { borderRadius: '8px' } }}>
      <VStack rootStyle={[styles.container]} gap={3}>
        <Box display="flex" justifyContent="center" p="7px 9px">
          <Text variant="h4">{title}</Text>
        </Box>
        <Box>
          <Text variant="body" color={colors.grey800}>
            {content}
          </Text>
        </Box>
        <Button onClick={() => { closeDialog(); onConfirm?.() }}>我知道了</Button>
      </VStack>
    </Dialog>
  )
}
